import React, { useState } from 'react';
import { Play, Pause } from 'lucide-react';
import { ChineseMode } from '../../types';
import { CHINESE_MODES } from '../../data/mockData';
import { playNote } from '../../utils/audioUtils';
const MODES: ChineseMode[] = ['宫调', '商调', '角调', '徵调', '羽调'];
export function ModesExplorer() {
  const [selectedMode, setSelectedMode] = useState<ChineseMode>('宫调');
  const [isPlaying, setIsPlaying] = useState(false);
  const [activeNote, setActiveNote] = useState<number | null>(null);
  const playModeScale = async () => {
    if (isPlaying) return;
    setIsPlaying(true);
    const mode = CHINESE_MODES[selectedMode];
    const pitchMap: Record<string, string> = {
      do: '1',
      re: '2',
      mi: '3',
      sol: '5',
      la: '6'
    };
    for (let i = 0; i < mode.notes.length; i++) {
      setActiveNote(i);
      playNote(pitchMap[mode.notes[i]] || '1');
      await new Promise(resolve => setTimeout(resolve, 500));
    }
    setActiveNote(null);
    setIsPlaying(false);
  };
  return <div className="flex flex-col items-center w-full max-w-4xl mx-auto" data-id="element-99">
      {/* Colorful wheel */}
      <div className="relative w-72 h-72 mb-8" data-id="element-100">
        <svg viewBox="0 0 200 200" className="w-full h-full" data-id="element-101">
          {MODES.map((mode, i) => {
          const angle = (i * 72 - 90) * (Math.PI / 180);
          const nextAngle = ((i + 1) * 72 - 90) * (Math.PI / 180);
          const x1 = 100 + 80 * Math.cos(angle);
          const y1 = 100 + 80 * Math.sin(angle);
          const x2 = 100 + 80 * Math.cos(nextAngle);
          const y2 = 100 + 80 * Math.sin(nextAngle);
          const largeArc = 0;
          const isSelected = selectedMode === mode;
          const modeData = CHINESE_MODES[mode];
          return <g key={mode} data-id="element-102">
                <path d={`M 100 100 L ${x1} ${y1} A 80 80 0 ${largeArc} 1 ${x2} ${y2} Z`} fill={modeData.color} stroke="white" strokeWidth="2" className={`cursor-pointer transition-all ${isSelected ? 'opacity-100' : 'opacity-70 hover:opacity-90'}`} onClick={() => setSelectedMode(mode)} data-id="element-103" />
                <text x={100 + 50 * Math.cos(angle + 36 * Math.PI / 180)} y={100 + 50 * Math.sin(angle + 36 * Math.PI / 180)} textAnchor="middle" dominantBaseline="middle" className="text-sm font-bold fill-white pointer-events-none" data-id="element-104">
                  {mode.replace('调', '')}
                </text>
              </g>;
        })}
          {/* Center circle */}
          <circle cx="100" cy="100" r="30" fill="white" className="drop-shadow-lg" data-id="element-105" />
        </svg>

        {/* Play button in center */}
        <button onClick={playModeScale} disabled={isPlaying} className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-14 h-14 bg-white rounded-full shadow-lg flex items-center justify-center hover:scale-110 transition-transform" data-id="element-106">
          {isPlaying ? <Pause className="w-6 h-6 text-gray-700" data-id="element-107" /> : <Play className="w-6 h-6 text-gray-700 ml-1" data-id="element-108" />}
        </button>
      </div>

      {/* Mode info */}
      <div className="bg-white rounded-2xl p-6 shadow-lg w-full max-w-md" data-id="element-109">
        <div className="flex items-center justify-between mb-4" data-id="element-110">
          <h3 className="text-2xl font-bold" style={{
          color: CHINESE_MODES[selectedMode].color
        }} data-id="element-111">
            {selectedMode}
          </h3>
          <div className="flex gap-2" data-id="element-112">
            {CHINESE_MODES[selectedMode].notes.map((note, i) => <div key={i} className={`w-10 h-10 rounded-lg flex items-center justify-center text-white font-bold transition-all ${activeNote === i ? 'scale-125 shadow-lg' : ''}`} style={{
            backgroundColor: CHINESE_MODES[selectedMode].color
          }} data-id="element-113">
                {note}
              </div>)}
          </div>
        </div>
        <p className="text-gray-600" data-id="element-114">
          {CHINESE_MODES[selectedMode].description}
        </p>
      </div>

      {/* Instructions */}
      <div className="mt-8 text-center text-gray-500 max-w-md" data-id="element-115">
        <p data-id="element-116">点击轮盘选择不同的调式，然后按中间的播放按钮听听它们的区别！</p>
        <p className="mt-2 text-sm" data-id="element-117">
          每种调式都有独特的情感色彩，试着感受一下吧~
        </p>
      </div>
    </div>;
}